module.exports = __webpack_public_path__ + "img/say-hello.8d2ea815.svg";